import { store } from '@/store';
import api from '@api/Api';

export default {

    login(params) {
        params.app = true;
        return api().post('/auth/login', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            return response;
        });
    },

    signup(params) {
        params.app = true;
        return api().post('/auth/signup', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            return response;
        });
    },

    google(params) {
        params.app = true;
        return api().post('/auth/google', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            return response;
        });
    },

    sso(params) {
        params.app = true;
        return api().post('/auth/sso', params).then((response) => {
            store.commit('setApiKey', response.data.data.api_key);
            return response;
        });
    },

    resetPassword(params) {
        return api().post('/auth/password-reset', params);
    },

    changePassword(params) {
        return api().post('/auth/password-change', params);
    },

    verifyEmail(params) {
        return api().post('/auth/verify-email', params);
    },

    logout() {
        return api().post('/auth/logout');
    },

    /**
     * MFA
     */

    getMFA() {
        return api().get('/auth/mfa');
    },

    createMFA(params) {
        return api().post('/auth/mfa', params);
    },

    deleteMFA(params) {
        return api().delete('/auth/mfa', params);
    },

    verifyMFA(params) {
        return api().post('/auth/mfa/verify', params);
    },
}
